RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const MetricPie = App.widgets.Chart.extend({
        chartType: RivalIQ.graph.PieChart,

        loadData: function () {
            const me = this;
            const metric = me.dashboardModel.metric;

            if (!me.dashboardModel.isExporting() && metric.get('companyId')) {
                metric.attributes.companyId = RivalIQ.state.utils.getFocusedCompanyId();
            }

            if (metric && metric.modern) {
                return metric.fetch().done(function (metric) {
                    me.model = metric;
                });
            }

            return App.widgets.Chart.prototype.loadData.apply(me, arguments);
        },

        getChartAttributes: function () {
            const me = this;

            let data;
            if (!me.collection) {
                data = me.model.getValue({
                    format: false
                });

                if (!data || !data.length && me.getProp('dimension')) {
                    data = [[me.model.get(me.getProp('dimension')), data]];
                }

                // reject empty segments
                data = _.reject(data, function (pair) {
                    return pair[1] <= 0;
                });
            } else {
                data = _.map(me.collection.invoke('getValue', {
                    format: false
                }), function (value) {
                    return [value];
                });
            }

            return {
                data: data,
                concept: (me.collection ? me.collection.toArray() : me.model),
                height: me.getProp('height'),
                width: me.getProp('width')
            };
        }
    });

    const MetricPieChartWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: MetricPie,

        processProps: function (props) {
            const me = this;

            props = widgets.Chart.buildMetrics(me, props);

            return props;
        }
    });
    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_PIE_CHART, MetricPieChartWidget);
});
